/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./background-color.vue?vue&type=template&id=33156880&scoped=true&"
import script from "./background-color.vue?vue&type=script&lang=js&"
export * from "./background-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33156880",
  null
  
)

export default component.exports